import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'kon-nested-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  template: `
    <ng-content></ng-content>
    <router-outlet (deactivate)="onDeactivate()"></router-outlet>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NestedLayoutComponent {
  @Output() deactivate = new EventEmitter<void>();
  onDeactivate() {
    this.deactivate.emit();
  }
}
